import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allMachines } from 'app/mocks/data/machines/all'

import { api } from 'app/utils/constants'

export const unlockHatch = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.distributors.hatch.UNLOCK}`,
    ({ params }) => {
        const { id } = params

        const machineFound = allMachines.find(
            (machine) => machine.id.toString() === id,
        )

        // Not found
        if (!machineFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json(undefined, {
            status: StatusCodes.NO_CONTENT,
        })
    },
)
